import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { formatDate } from 'app/helpers/formatDate';
import { sortCompare } from 'app/helpers/sortCompare';
import { ListAudkenningarLogsRes } from 'app/interfaces/responses/List/listAudkenningarLogsRes';
import { LsrauthService } from 'app/services/api/lsrauth/lsrauth.service';

@Component({
    selector: 'app-audkenning-skoda-beidnir',
    templateUrl: './audkenning-skoda-beidnir.component.html',
    styleUrls: ['./audkenning-skoda-beidnir.component.scss'],
})
export class AudkenningSkodaBeidnirComponent implements OnInit {
    @ViewChild('tablePaginator ') displayedDataPaginator: MatPaginator;
    orgRequestsColumns: string[] = ['audkenningarLogsId', 'authMessage', 'authMessageExtra', 'name', 'userId', 'userEmail', 'timeStamp'];
    displayedData: MatTableDataSource<ListAudkenningarLogsRes> = new MatTableDataSource();

    loaded: boolean = false;

    formatDate(date) {
        return formatDate(date);
    }

    constructor(private lsrauthService: LsrauthService) {
        this.getAuthRequests();
    }

    ngOnInit(): void {}

    ngAfterViewInit(): void {
        this.displayedData.paginator = this.displayedDataPaginator;
    }

    getAuthRequests() {
        this.lsrauthService.getPublicAuthRequest().subscribe((requests) => {
            requests.sort((a, b) => {
                return new Date(b.timeStamp).getTime() - new Date(a.timeStamp).getTime();
            });
            this.displayedData.data = requests;
            this.loaded = true;
        });
    }

    //#region Table Sort and Filter

    searchFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
        this.displayedData.filter = filterValue;
    }

    sortData(sort: Sort) {
        const data = this.displayedData.data.slice();
        if (!sort.active || sort.direction === '') {
            this.displayedData.data = data;
            return;
        }

        this.displayedData.data = data.sort((a, b) => {
            const isAsc = sort.direction === 'asc';
            switch (sort.active) {
                case 'audkenningarLogsId':
                    return sortCompare(a.audkenningarLogsId, b.audkenningarLogsId, isAsc);
                case 'authMessage':
                    return sortCompare(a.authMessage, b.authMessage, isAsc);
                case 'authMessageExtra':
                    return sortCompare(a.authMessageExtra, b.authMessageExtra, isAsc);
                case 'name':
                    return sortCompare(a.name, b.name, isAsc);
                case 'ssn':
                    return sortCompare(a.ssn, b.ssn, isAsc);
                case 'userId':
                    return sortCompare(a.userId, b.userId, isAsc);
                case 'timeStamp':
                    return sortCompare(a.timeStamp, b.timeStamp, isAsc);
                default:
                    return 0;
            }
        });
    }

    //#endregion
}
